<template>	
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <!-- Breadcrumb -->
    <div class="mb-3 row">
      <div class="col-11">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/tramite">Trámites</router-link></li>
            <li class="breadcrumb-item">
              <router-link :to="`/tramiteform/${p_idTramite}`">
                Trámite N.° {{ p_idTramite }}
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Archivos CSV</li>
          </ol>
        </nav>
      </div>
      <div class="col-1 text-end">
        <span
          class="material-symbols-outlined text-primary"
          style="font-size: 32px; cursor: pointer"
          @click="showModalHelp = true"
        >
          help
        </span>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="row">
            <div class="col-9" style="text-align: left">
              <div class="row">
              </div>
            </div>

            <div class="col-3" style="text-align: right">
              <button
                class="btn btn-outline-secondary d-inline-flex align-items-center gap-1"
                @click.prevent="mostrarOcultarBloque"
                style="
                  padding-top: 0.1rem;
                  padding-bottom: 0.1rem;
                  padding-left: 0.5rem;
                  padding-right: 0.5rem;
                "
              >
                <span class="material-icons" style="font-size: 1.1rem">
                  {{
                    mostrarBloque
                      ? "remove_circle_outline"
                      : "add_circle_outline"
                  }}
                </span>
                {{ mostrarBloque ? "Menos información" : "Más información" }}
              </button>
            </div>
          </div>
          <div v-if="mostrarBloque" class="mb-3">
            <div class="modal-body">

            <div class="mb-1">
              <div class="row">
                <div class="col-1">
                  <label for="numero" class="form-label">Numero</label>
                </div>
                <div class="col-2">
                  <input type="text" class="form-control" id="numero" name="numero" v-model="datoPlanilla.numero" style='text-transform:uppercase' required>
                </div>
                <div class="col-4">
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="planillaSiguiente"
                    title="Obtener número de planilla siguiente"
                  >
                    Planilla siguiente
                  </button>
                </div>
                <div class="col-1">
                  <label for="idTramite" class="form-label fw-bold">Cod. V.</label>
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="idTramite"
                    name="idTramite"
                    v-model="datoPlanilla.codigoVal"
                  />
                </div>
              </div>
            </div>

            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="cedula" class="form-label">Cedula</label>
                </div>
                <div class="col-2">
                <input type="text" class="form-control" id="cedula" name="cedula" v-model="datoPlanilla.cedula" style='text-transform:uppercase' required>
                </div>
                <div class="col-1">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-4">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoPlanilla.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>

<div class="mb-1">
  <div class="row">
    <div class="col-11">
			
<div class="mb-1" v-for="n in 2" :key="'diag' + n">
  <div class="row">
    <div class="col-1">
      <label :for="'diag' + n" class="form-label fw-bold">Diag {{ n }}</label>
    </div>

    <!-- SELECT de códigos -->
    <div class="col-2">
      <input type="text" class="form-control me-2" :id="'diag' + n" v-model="datoPlanilla['diag' + n]" :required="n < 3" readonly />
    </div>

    <!-- Mostrar descripción automáticamente -->
    <div class="col-7">
      <input
        type="text"
        class="form-control"
		v-model="nombre_diag[n]"
        disabled
      >
    </div>

    <!-- SELECT de códigos -->
    <div class="col-1">
<span 
  @click="abrirModalDiagnosticos('diag' + n)"
  data-bs-toggle="modal"
  data-bs-target="#ModalDiagnosticoLOV"
  title="Buscar diagnóstico"
  class="btn btn-outline-info d-inline-flex align-items-center justify-content-center rounded-circle"
  style="width: 40px; height: 40px; cursor: pointer;"
>
  <span class="material-symbols-outlined" style="font-size: 24px;">
    search
  </span>
</span>
    </div>

    <!-- Checkbox -->
<div class="col-1 d-flex align-items-center justify-content-center">
  <div class="form-check form-switch">
    <input
      class="form-check-input"
      type="checkbox"
      role="switch"
      v-model="datoPlanilla['controlDiag' + n]"
      :true-value="1"
      :false-value="0"
      :title="datoPlanilla['controlDiag' + n] === 1 ? 'Desactivar' : 'Activar'"
      @change="onToggleDiag(n)"
      v-bind="datoPlanilla['controlDiag' + n] === 0 ? { 'data-bs-toggle': 'modal', 'data-bs-target': '#ModalDiagnosticoLOV' } : {}"
    >
  </div>
</div>
	
  </div>
</div>

    </div>
	
    <div class="col-1">

    <!-- Botón para mostrar/ocultar diagnósticos 3, 4, 5 -->
    <div class="d-flex justify-content-end mt-2">
    <button
      class="btn btn-outline-secondary d-inline-flex align-items-center gap-1 mt-2"
      @click.prevent="mostrarOcultarDiagExtra"
      style="
        padding-top: 0.1rem;
        padding-bottom: 0.1rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      "
    >
      <span class="material-icons" style="font-size: 1.1rem">
        {{ mostrarDiagExtra ? "remove_circle_outline" : "add_circle_outline" }}
      </span>
    </button>
    </div>

	
    </div>	
	
  </div>
</div>

<div class="mb-1">
  <div class="row">
    <div class="col-11">

    <!-- Diagnósticos 3, 4, 5 (ocultos por defecto) -->
    <div v-if="mostrarDiagExtra" class="mt-1">
<div class="mb-1" v-for="n in [3, 4, 5]" :key="'diag' + n">
  <div class="row">
    <div class="col-1">
      <label :for="'diag' + n" class="form-label fw-bold">Diag {{ n }}</label>
    </div>

    <!-- SELECT de códigos -->
    <div class="col-2">
      <input type="text" class="form-control me-2" :id="'diag' + n" v-model="datoPlanilla['diag' + n]" :required="n < 3" readonly />
    </div>

    <!-- Mostrar descripción automáticamente -->
    <div class="col-7">
      <input
        type="text"
        class="form-control"
		v-model="nombre_diag[n]"
        disabled
      >
    </div>

    <!-- SELECT de códigos -->
    <div class="col-1">
<span 
  @click="abrirModalDiagnosticos('diag' + n)"
  data-bs-toggle="modal"
  data-bs-target="#ModalDiagnosticoLOV"
  title="Buscar diagnóstico"
  class="btn btn-outline-info d-inline-flex align-items-center justify-content-center rounded-circle"
  style="width: 40px; height: 40px; cursor: pointer;"
>
  <span class="material-symbols-outlined" style="font-size: 24px;">
    search
  </span>
</span>
    </div>

    <!-- Checkbox -->
<div class="col-1 d-flex align-items-center justify-content-center">
  <div class="form-check form-switch">
    <input
      class="form-check-input"
      type="checkbox"
      role="switch"
      v-model="datoPlanilla['controlDiag' + n]"
      :true-value="1"
      :false-value="0"
      :title="datoPlanilla['controlDiag' + n] === 1 ? 'Desactivar' : 'Activar'"
      @change="onToggleDiag(n)"
      v-bind="datoPlanilla['controlDiag' + n] === 0 ? { 'data-bs-toggle': 'modal', 'data-bs-target': '#ModalDiagnosticoLOV' } : {}"
    >
  </div>
</div>
	
  </div>
</div>
</div>

    </div>
    <div class="col-1">

	
    </div>
  </div>
</div>

              <hr />

            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="cedulaMedico" class="form-label">Médico</label>
                </div>
                <div class="col-2">
                <input type="text" class="form-control" id="cedulaMedico" name="cedulaMedico" v-model="datoPlanilla.cedulaMedico" style='text-transform:uppercase' required>
                </div>
                <div class="col-5">
                <input type="text" class="form-control" id="nombreMedico" name="nombreMedico" v-model="datoPlanilla.nombreMedico" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>

              <hr />
              <div class="mb-1">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Fecha desde</label>
                    <input type="date"
                           class="form-control"
                           id="fechaDesde"
                           name="fechaDesde"
                           v-model="datoPlanilla.fechaDesde"
                           :min="getFormattedDateISO(datoPlanilla.fechaDesdeCarga)"
                           :max="getFormattedDateISO(datoPlanilla.fechaHastaCarga)"
                           required>
                  </div>
                  <div class="col-2">
                    <label class="form-label fw-bold">Hora desde</label><br />
                    <span><input type="time" class="form-control" id="horaDesde" name="horaDesde" v-model="datoPlanilla.horaDesde" style='text-transform:uppercase' required></span>
                  </div>
                  <div class="col-2">
                    <label class="form-label fw-bold">Fecha hasta</label>
                    <input type="date"
                           class="form-control"
                           id="fechaHasta"
                           name="fechaHasta"
                           v-model="datoPlanilla.fechaHasta"
                           :min="getFormattedDateISO(datoPlanilla.fechaDesdeCarga)"
                           :max="getFormattedDateISO(datoPlanilla.fechaHastaCarga)"
                           required>
                  </div>
                  <div class="col-2">
                    <label class="form-label fw-bold">Hora hasta</label><br />
                    <span><input type="time" class="form-control" id="horaHasta" name="horaHasta" v-model="datoPlanilla.horaHasta" style='text-transform:uppercase' required></span>
                  </div>
<div class="col-auto">
  <button
    type="button"
    class="btn btn-outline-primary d-flex align-items-center gap-2"
    @click="datoPlanilla.idPlanilla ? actualizarPlanilla() : guardarPlanilla()"
    :title="datoPlanilla.idPlanilla ? 'Actualizar planilla' : 'Guardar planilla'"
    :aria-label="datoPlanilla.idPlanilla ? 'Actualizar planilla' : 'Guardar planilla'"
  >
    <span 
      class="material-symbols-outlined"
      style="font-size: 24px"
      aria-hidden="true"
    >
      {{ datoPlanilla.idPlanilla ? 'update' : 'save' }}
    </span>
    <span class="d-none d-md-inline">
      {{ datoPlanilla.idPlanilla ? 'Actualizar' : 'Guardar' }}
    </span>
  </button>
</div>

<div class="col-auto">
  <button
    v-if="datoPlanilla.idPlanilla"
    type="button"
    class="btn btn-outline-warning d-flex align-items-center gap-2"
    @click="actualizarPendiente()"
    title="Marcar como pendiente"
    aria-label="Marcar planilla como pendiente"
  >
    <span 
      class="material-symbols-outlined"
      style="font-size: 24px"
      aria-hidden="true"
    >
      schedule
    </span>
    <span class="d-none d-md-inline">
      Pendiente
    </span>
  </button>
</div>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>
    <br />
    <!-- Estructura de Tabs -->
    <div class="tabs">
      <button
        class="tablink"
        @click="showTable = 'procedimientos'"
        :class="{ 'active-tab': showTable === 'procedimientos' }"
      >
        <span class="material-symbols-outlined"> stacks </span>
        TPSNS
      </button>
      <button
        class="tablink"
        @click="showTable = 'medicamentos'"
        :class="{ 'active-tab': showTable === 'medicamentos' }"
      >
        <span class="material-symbols-outlined"> stacks </span>
        Medicamentos
      </button>
      <button
        class="tablink"
        @click="showTable = 'insumos'"
        :class="{ 'active-tab': showTable === 'insumos' }"
      >
        <span class="material-symbols-outlined"> stacks </span>
        Insumos
      </button>
    </div>

    <!-- Contenido dinámico según la pestaña seleccionada -->
    <div v-if="showTable === 'procedimientos'">
      <PlanillaDetCrear
        :p_tipoElemento="'procedimientos'"
        :p_idPlanilla="Number(p_idPlanilla)"
		:p_idClasElem="2"
        :p_fechaDesde="normalizeDate(datoPlanilla.fechaDesde)"
        :p_fechaHasta="normalizeDate(datoPlanilla.fechaHasta)"
      >
      </PlanillaDetCrear>
    </div>
    <div v-if="showTable === 'medicamentos'">
      <PlanillaDetCrear
        :p_tipoElemento="'medicamentos'"
        :p_idPlanilla="Number(p_idPlanilla)"
		:p_idClasElem="10"
        :p_fechaDesde="normalizeDate(datoPlanilla.fechaDesde)"
        :p_fechaHasta="normalizeDate(datoPlanilla.fechaHasta)"
      >
      </PlanillaDetCrear>
    </div>
    <div v-if="showTable === 'insumos'">
      <PlanillaDetCrear
        :p_tipoElemento="'insumos'"
        :p_idPlanilla="Number(p_idPlanilla)"
		:p_idClasElem="11"
        :p_fechaDesde="normalizeDate(datoPlanilla.fechaDesde)"
        :p_fechaHasta="normalizeDate(datoPlanilla.fechaHasta)"
      >
      </PlanillaDetCrear>
    </div>

      <DiagnosticoLOV @DatosDiagnostico="asignarDiagnostico" />
    <Footer />
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue';
import Footer from '@/components/Footer.vue';
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
//import { registrarBitacoraTramite } from "@/modules/bitacoraTramite.js";
import PlanillaDetCrear from "../forms/PlanillaDetCrear.vue";
import DiagnosticoLOV from "@/components/lovs/DiagnosticoLOV.vue";

import Swal from "sweetalert2";
import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
export default {
  components: {
    Layout,
    Footer,
    PlanillaDetCrear,
    DiagnosticoLOV
  },
  data() {
    return {
      planillas: [],
      datoPlanilla: {},
      nombreBusqueda: "",
      titulo: "",
      modalWindow: true,
      p_idTramite: 0,
      p_estadoTramite: 0,
      p_idPlanilla: 0,
      p_tipoConsulta: "",
      idPerfil: 0,
      idUsuario: 0,
      showTable: "", // Pestaña por defecto
      tramites: [],
      nombre_diag: {
        1: null,
        2: null,
        3: null,
        4: null,
        5: null
      },
      mensaje: "",
      success: false,
      mostrarBloque: true,
      mostrarDiagExtra: false,
      pendientesRevision: 0,
      tipo: "",
      campoDiagnosticoActivo: '',
    };
  },
  computed: {
    supervisorAM() {
      return (
        (this.idPerfil == 17) &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
    consultaAM() {
      return (
        (this.idPerfil == 17 || this.idPerfil == 18) &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
    consultaGD() {
      return (
        (this.idPerfil == 19 || this.idPerfil == 20) &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
  },
  mounted() {

    this.p_idTramite = this.$route.params.p_idtramite;
//    this.p_estadoTramite = this.$route.params.p_estadotramite;
    this.p_idPlanilla = this.$route.params.p_idplanilla;
//    this.p_tipoConsulta = this.$route.params.p_tipoconsulta;

    this.idPerfil = window.sessionStorage.getItem("idPerfil");
    this.idUsuario = window.sessionStorage.getItem("idUsuario");
    this.tipo = this.idPerfil == 17 || this.idPerfil == 18 ? "M" : "D";
    this.getData();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    getFormattedDateISO(date) {
      return dateFormat.getFormattedDateISO(date);
    },
    normalizeDate(dateString) {
      // Asegura que la fecha sea un objeto Date con hora 00:00:00 en GMT-5
      const [year, month, day] = dateString.split('-');
      return new Date(`${year}-${month}-${day}T00:00:00.000-05:00`);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    async getData() {
	
      if(this.p_idPlanilla != 0){
        await api.get("/vwplanillaexts/" + this.p_idPlanilla)
          .then((response) => {
            this.datoPlanilla = response.data;
            this.datoPlanilla.fechaDesde = dateFormat.getFormattedDateISO(
              this.datoPlanilla.fechaDesde
            );
            this.datoPlanilla.fechaHasta = dateFormat.getFormattedDateISO(
              this.datoPlanilla.fechaHasta
            );
            this.fetchDiagnosticos();
          })
          .catch((error) => {
            console.error("Error al obtener datos de la planilla:", error);
          });
      }
    },
    validarForm() {
      const requiredFields = [
        "idTramite",
        "numero",
        "cedula",
        "nombre",
        "diag1",
//        "diag2",
        "fechaDesde",
        "fechaHasta",
      ];
      const requiredFieldsText = [
        "idTramite",
        "numero",
        "cedula",
        "nombre",
        "diag1",
//        "diag2",
        "fechaDesde",
        "fechaHasta",
      ];
      return validarForm(this.datoPlanilla, requiredFields, requiredFieldsText);
    },
    async guardarPlanilla(){
      this.datoPlanilla.idTramite = this.p_idTramite;
      if(this.validarForm() === 1){
        try {
          this.datoPlanilla.idUsuarioReg = this.idUsuario;
          this.datoPlanilla.fechaReg = new Date();

          const response = await api.post('/planillas', this.datoPlanilla);
          this.p_idPlanilla = response.data.idPlanilla;
          await this.getData();

          Swal.fire({
            icon: 'success',
            title: 'Éxito',
            text: '¡Planilla guardada exitosamente!',
            confirmButtonText: 'Aceptar'
          });

          this.$router.replace(
            `/planillacrearform/${this.p_idTramite}/${this.p_idPlanilla}`
          );

        } catch (error) {
          let mensaje = '¡Inténtelo de nuevo!';

          if (error.response && error.response.data && error.response.data.mensaje) {
            mensaje = error.response.data.mensaje;
          }

          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: mensaje,
            confirmButtonText: 'Aceptar'
          });
        }
      }
    },	
    async actualizarPlanilla(){
      if(!this.datoPlanilla.diag2 && this.tipo == 'M'){
Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'El segundo diagnóstico no puede ser nulo',
  confirmButtonText: 'Aceptar'
});
          return;
      }
      if(this.validarForm() === 1){
        try {
          this.datoPlanilla.idUsuarioAct = this.idUsuario;
          this.datoPlanilla.fechaAct = new Date();
          await api.post('/planillas', this.datoPlanilla)
  Swal.fire({
    icon: 'success',
    title: 'Éxito',
    text: '¡Planilla actualizada exitosamente!',
    confirmButtonText: 'Aceptar'
  });

} catch (error) {
  Swal.fire({
    icon: 'error',
    title: 'Error',
    text: '¡Inténtelo de nuevo!',
    confirmButtonText: 'Aceptar'
  });
}
      }
    },
    async actualizarPendiente(){
      if(!this.datoPlanilla.diag2 && this.tipo == 'M'){
Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'El segundo diagnóstico no puede ser nulo',
  confirmButtonText: 'Aceptar'
});
          return;
      }
      if(this.validarForm() === 1){
        try {
          this.datoPlanilla.idUsuarioAct = this.idUsuario;
          this.datoPlanilla.fechaAct = new Date();
          await api.post('/planillas/guardar-pendiente', this.datoPlanilla)
  Swal.fire({
    icon: 'success',
    title: 'Éxito',
    text: '¡Planilla actualizada a "Pendiente" exitosamente!',
    confirmButtonText: 'Aceptar'
  });

} catch (error) {
  Swal.fire({
    icon: 'error',
    title: 'Error',
    text: '¡Inténtelo de nuevo!',
    confirmButtonText: 'Aceptar'
  });
}
      }
      this.$router.push(
        "/tramiteform/" + this.p_idTramite
      );
    },
    async fetchNombreDiagnostico(codigo) {
      try {
        const response = await api.get(`/vwdiagnosticos/codigo-sin-punto/${codigo}`
        );

        // Asegúrate de que la respuesta contiene datos y es un array
        const diagnosticos = response.data;

        if (Array.isArray(diagnosticos) && diagnosticos.length > 0) {
          const nombre = diagnosticos[0].nombre; // Accede al 'nombre' del primer elemento
          return nombre;
        } else {
          return "Diagnóstico no encontrado";
        }
      } catch (error) {
        return "Error al cargar";
      }
    },
    async fetchDiagnosticos() {
      const codigos = [
        this.datoPlanilla.diag1,
        this.datoPlanilla.diag2,
        this.datoPlanilla.diag3,
        this.datoPlanilla.diag4,
        this.datoPlanilla.diag5,
      ];

      const nombres = await Promise.all(
        codigos.map((codigo) =>
          codigo ? this.fetchNombreDiagnostico(codigo) : null
        )
      );

      this.nombre_diag[1] = nombres[0];
      this.nombre_diag[2] = nombres[1];
      this.nombre_diag[3] = nombres[2];
      this.nombre_diag[4] = nombres[3];
      this.nombre_diag[5] = nombres[4];
    },

  abrirModalDiagnosticos(campo) {
    this.campoDiagnosticoActivo = campo;
  },
  asignarDiagnostico(diagnostico) {
    if (this.campoDiagnosticoActivo) {
      this.datoPlanilla[this.campoDiagnosticoActivo] = diagnostico.codigo;
      const num = this.campoDiagnosticoActivo.replace('diag', '');
      this.nombre_diag[num] = diagnostico.nombre;
    }
  },
  onToggleDiag(n) {
    const control = this.datoPlanilla['controlDiag' + n];
    if (control === 1) {
      this.seleccionar(n);
    } else {
      this.borrar(n);
    }
  },

  seleccionar(n) {
    this.abrirModalDiagnosticos('diag' + n);
    console.log('Seleccionar diagnóstico', n);
  },

  borrar(n) {
    this.datoPlanilla['diag' + n] = null;
	this.nombre_diag[n] = null;
    console.log('Borrar diagnóstico', n);
  },

  marcarPendiente(campo) {
    this.datoPlanilla[campo] = 'PENDIENTE';
  },
  mostrarOcultarDiagExtra() {
    this.mostrarDiagExtra = !this.mostrarDiagExtra;
  },
async planillaSiguiente() {
  try {
    const response = await api.post('/procedimientos/planilla-siguiente', null, {
      params: {
        idTramite: this.p_idTramite
      }
    });
    this.datoPlanilla.numero = response.data;
  } catch (error) {
    Swal.fire("Error", "No se pudo obtener el número de planilla", "error");
  }
},
  },
};
</script>

<style src="@/assets/css/tabs.css" scoped></style>

<style scoped>
.input-group {
  display: flex;
  gap: 10px;
  align-items: center;
}
</style>

<style scoped>
.btn {
  font-size: 16px;
  padding: 10px 20px;
}

.alert {
  margin-top: 20px;
  padding: 10px;
  border-radius: 5px;
}

.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
</style>
<style scoped>
.texto-rojo {
  color: red;
  font-weight: bold; /* Negrilla */
  background-color: #ffe5b4; /* Fondo amarillo */
}
.texto-aviso {
  color: #b30000; /* Rojo suave, más elegante que "red" puro */
  font-weight: 600; /* Negrilla moderada */
  background-color: #fff3cd; /* Fondo cálido tipo alerta suave */
  padding: 8px 12px;
  border-radius: 6px;
  border-left: 4px solid #f0ad4e; /* Detalle visual */
  font-size: 14px;
}
</style>
